import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import swal from "sweetalert";
import { DropdownBox, InputBox, SubmitButton } from "../../components/Input";

const Watchlist = () => {
  const [watchlist, setWatchlist] = useState([
    { id: 1, title: "Inraday Stocks" },
    { id: 2, title: "Index Opstion" },
    { id: 3, title: "Stock Future" },
  ]);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this Record!",
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, delete it!"],
    }).then((willDelete) => {
      if (willDelete) {
        setWatchlist(watchlist.filter((item) => item.id !== id));
        swal("Poof! Your record has been deleted!", {
          icon: "success",
        });
      } else {
        swal("Your record is safe!");
      }
    });
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };
 
  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="row pb-2">
          <div className="col-md-6">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/dashboard">
                    <i className="ti ti-home"></i> Home
                  </a>
                </li>
                <li className="breadcrumb-item active">Manage Watchlist</li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6" style={{ textAlign: "right" }}>
            <button
              className="btn btn-default bg-white btn-sm"
              onClick={openModal}
            >
              <i className="ti ti-plus"></i> Add Watchlist
            </button>
          </div>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow p-10">
          {watchlist.length > 0 ? (
            <table className="table table-condensed table-bordered bg-white">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>#</th>
                  <th>Title</th>
                  <th style={{ width: "20%" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {watchlist.map((post, index) => (
                  <tr key={post.id}>
                    <td
                      style={{ textAlign: "center", verticalAlign: "middle" }}
                    >
                      {index + 1}
                    </td>
                    <td>{post.title}</td>
                    <td>
                      <button
                        className="mx-2 btn btn-warning btn-xs"
                        style={{ float: "left" }}
                      >
                        <i className="ti ti-pencil"></i>
                      </button>
                      <button
                        onClick={() => handleDelete(post.id)}
                        className="btn btn-danger btn-xs"
                        style={{ float: "left" }}
                      >
                        <i className="ti ti-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>No records found.</div>
          )}
        </div>
      </div>

      {/* Modal for adding a watchlist */}
      <Modal
        show={showModal}
        onHide={closeModal}
      >
        <form action="">
          <Modal.Header closeButton>
          <h5 class="modal-title" style={{ fontWeight: "bold" }}>Add Watchlist</h5>
          </Modal.Header>
          <Modal.Body>
            <input type="hidden" name="delid" id="delid" value="0" />
            <div className="row">
              <div className="mt-2 col-md-12">
                <DropdownBox
                  label="Service"
                  fieldname="serviceid"
                  options={[
                    { label: "- Select -", value: "" },
                    { label: "PREMIUM STOCKE", value: "PREMIUM STOCKE" },
                    { label: "SWING TRADING", value: "SWING TRADING" },
                    { label: "POSISNAL STOCKS", value: "POSISNAL STOCKS" },
                  ]}
                  onChange=""
                  value=""
                />
              </div>
              <div className="mt-2 col-md-12">
                <InputBox
                  label="Symbol"
                  fieldname="symbol"
                  placeholder="Enter Symbol"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-primary submitBtn" type="submit">
              Save Changes
            </button>
            <button className="btn btn-default" onClick={closeModal}>
              Cancel
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};

export default Watchlist;
